import {
  Attachment,
  PlpAttachmentsNameE,
  PlpAttachmentsRuleE,
} from '@/scripts/libs/algolia/types/plp'
import AlgoliaProductsUtils from '@/scripts/libs/algolia/products'
import { PlpColor } from '@/types/plp'

export default class RbProductTile {
  static wornImageExclusive(attachment: Array<Attachment>): string {
    const wornImage =
      attachment
        ?.filter((att) => {
          return att.name === PlpAttachmentsNameE.ON_MODEL && att.url.indexOf('.mp4') === -1
        })
        ?.sort((a, b) => a.sequence - b.sequence) || []
    const { url } = wornImage[0] || {}
    return url ? AlgoliaProductsUtils.composeProductImage(url) : ''
  }
  static mapAttachmentsExclusive(
    attachment: Array<Attachment>
  ): Array<{ images: { primary: string } }> {
    const orderImgs = [
      PlpAttachmentsNameE.SHAD_QT,
      PlpAttachmentsNameE.SHAD_LT,
      PlpAttachmentsNameE.SHAD_BK,
      PlpAttachmentsNameE.SHAD_CFR,
    ]
    return attachment
      ?.filter(
        (att) =>
          att.rule === PlpAttachmentsRuleE.PDP_CAROUSEL &&
          orderImgs.indexOf(att.name) !== -1 &&
          att.url.indexOf('.mp4') === -1
      )
      ?.sort((att1, att2) => {
        return orderImgs.indexOf(att1?.name) - orderImgs.indexOf(att2?.name)
      })
      ?.map((att) => ({
        ...att,
        images: {
          primary: AlgoliaProductsUtils.composeProductImage(att?.url),
        },
      }))
  }

  static hasWornImage(attachment: Array<Attachment>): boolean {
    return (
      attachment?.find(
        (att) => att.name === PlpAttachmentsNameE.ON_MODEL && att.rule === PlpAttachmentsRuleE.PLP
      )?.url !== ''
    )
  }

  static findWornImage(attachment: Array<Attachment>): any {
    return (
      attachment?.find(
        (att) =>
          att.name === PlpAttachmentsNameE.ON_MODEL &&
          att.rule === PlpAttachmentsRuleE.PLP &&
          (att.sequence === 2 || att.sequence === 1)
      ) || {}
    )
  }

  static getWornImagePosition(attachment: Array<Attachment>): string {
    return RbProductTile.findWornImage(attachment)?.sequence || ''
  }

  static getWornImage(attachment: Array<Attachment>): string {
    return RbProductTile.findWornImage(attachment)?.url || ''
  }
  static getTransitionImages(products: PlpColor): { desktop: string; mobile: string } {
    const defaultReturn = {
      desktop: '',
      mobile: '',
    }
    if (!products?.isTransition) {
      return defaultReturn
    }
    return (
      products.attachments?.reduce((acc, el) => {
        if (el.rule === PlpAttachmentsRuleE.PLP && el.sequence === 4) {
          acc.desktop = AlgoliaProductsUtils.composeProductImage(el.url)
        }
        if (el.rule === PlpAttachmentsRuleE.PLP && el.sequence === 3) {
          acc.mobile = AlgoliaProductsUtils.composeProductImage(el.url)
        }
        return acc
      }, defaultReturn) || defaultReturn
    )
  }
}
